import { render, staticRenderFns } from "./ExportDJU.vue?vue&type=template&id=10238d8b&scoped=true"
import script from "./ExportDJU.vue?vue&type=script&lang=ts"
export * from "./ExportDJU.vue?vue&type=script&lang=ts"
import style0 from "./ExportDJU.vue?vue&type=style&index=0&id=10238d8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10238d8b",
  null
  
)

export default component.exports